import React, { type ReactNode } from 'react';

import { Text } from '@atlaskit/primitives/compiled/text';

type KnowledgeCardCategoryProps = {
	children: ReactNode;
};

export const KnowledgeCardCategory = ({
	children,
}: KnowledgeCardCategoryProps): React.JSX.Element => {
	return <Text color="color.text.subtle">{children}</Text>;
};
